
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, loading, userProfile } = useAuth();
  
  useEffect(() => {
    // Don't do anything while auth is loading or user profile is loading
    if (loading || (currentUser && !userProfile)) return;
    
    // After auth state is determined, redirect based on authentication status
    if (currentUser) {
      // Redirect based on user role
      if (userProfile?.role === 'admin_user') {
        navigate("/dashboard");
      } else if (userProfile?.role === 'camp_manager' || userProfile?.role === 'camp_contributor') {
        navigate("/welcome");
      } else {
        // Unknown role or no role, redirect to welcome as fallback
        navigate("/welcome");
      }
    } else {
      // If user is not authenticated, redirect to login
      // and preserve the intended destination (which is root in this case)
      navigate("/login?returnUrl=%2F");
    }
  }, [navigate, currentUser, loading, userProfile]);
  
  // Show nothing while determining auth state
  return null;
};

export default Index;
